<template>
  <div>
    <Head title="Oferta de trabajo"></Head>    
    <!-- Start header with image -->
    <div class="container-fluid px-0">
      <div class="lpg-header position-relative">
        <img src="/images/lpg-rect-4.png" class="img-fluid vw-100" alt="..." />
      </div>
    </div>
    <!-- End header with image -->
    <!-- Start section one with image on right -->
    <div class="container-fluid px-0 mb-5">
        <div class="position-relative lpg-profile-cv"> 
            <div class="row g-0">
                <!-- left side -->
                <div class="col-12 col-md-4 col-lg-4 col-xl-3 px-4 pb-4 lpg-bg-green ">
                    <div class="d-flex justify-content-center align-items-center lpg-up-profile-pic">
                        <div class="d-flex flex-column">
                            <div class="mt-5 mb-3 text-center">
                                <!-- for tag on label must equal to input file id tag -->
                                <label for="lpg-file-upload" class="lpg-file-upload">
                                    <img :src="jobposting.company.logo_url">
                                </label>
                            </div>
                            <div class="mb-4 text-center">
                                <h2 class="mt-2 lpg-form-title fs-4">{{jobposting.company.name}}</h2>
                            </div>
                        </div>                    
                    </div>
                    <div class="lpg-form lpg-form-box px-0">                    
                        <section>
                            <div class="lpg-profile-content row row-cols-2 row-cols-md-1 gy-2">                                
                                <SidebarLinkItem
                                    v-if="jobposting.company.website_url"
                                    class="my-2"
                                    :label="jobposting.company.website_url"
                                    icon="bi bi-globe"
                                    :url="jobposting.company.website_url"
                                />
                                <SidebarLinkItem
                                    v-if="jobposting.company.fb_url"
                                    class="my-2"
                                    :label="jobposting.company.fb_url"
                                    icon="bi bi-facebook"
                                    :url="jobposting.company.fb_url"
                                />
                                <SidebarLinkItem
                                    v-if="jobposting.company.ig_url"
                                    class="my-2"
                                    :label="jobposting.company.ig_url"
                                    icon="bi bi-instagram"
                                    :url="jobposting.company.ig_url"
                                />
                                <SidebarLinkItem
                                    class="my-2"
                                    v-if="jobposting.company.linkedin_url"
                                    :label="jobposting.company.linkedin_url"
                                    icon="bi bi-linkedin"
                                    :url="jobposting.company.linkedin_url"
                                />
                            </div>                            
                        </section>
                    </div>
                </div>
                <!-- right side -->
                <div class="col-12 col-md col-lg text-start bg-white">                    
                    <div class="lpg-body-side-right">
                        <div class="lpg-form lpg-form-box px-0">
                            <div class="row mt-5">
                                <div class="col-12 text-end">
                                    <a class="btn btn-secondary mx-auto "
                                :href="'https://bolsadetrabajo.laprensagrafica.com/cvexcel/?jpid='+ jobposting.id+'&cid='+jobposting.company_id+'&auth='+auth_token.auth_token" >
                                        <i class="bi bi-file-earmark-arrow-down-fill" style="font-size: 2rem;"></i>
                                        Descargar
                                    </a>
                                    <Link
                                        class="btn btn-secondary mx-auto"
                                        aria-current="page"
                                        :href="$route('company.ofertas.edit',jobposting.id)"
                                    >
                                        <i class="bi bi-pencil-square" style="font-size: 2rem;"></i>
                                        Modificar información
                                    </Link>
                                    <button @click="deleteRow(jobposting.id)" type="button" class="btn btn-secondary mx-auto" >
                                        <i class="bi bi-trash" style="font-size: 2rem;"></i> Eliminar
                                    </button>
                                </div>
                            </div>                        
                            <section class="mt-3">
                                <div class="lpg-profile-content">
                                    <div class="row">
                                        <div class="col">
                                            <div class="card lpg-card lpg-card-white p-0 mb-3">
                                                <span class="lpg-title fs-3 mb-3">
                                                    {{jobposting.title}}
                                                </span>        
                                                <span class="fs-5 mb-3">
                                                    {{jobposting.category.name}}
                                                </span>                                                
                                                <div class="d-flex flex-column flex-lg-row gap-2">
                                                    <p class="lpg-desc flex-fill">
                                                        <span class="lpg-title fs-5">
                                                            Cargo:
                                                        </span>
                                                        {{jobposting.offered_position}}
                                                    </p>
                                                    <p class="lpg-desc flex-fill">
                                                        <span class="lpg-title fs-5">
                                                            Cantidad de oportunidades:
                                                        </span>
                                                        {{jobposting.vacancies}}
                                                    </p>
                                                </div>
                                                <div class="pt-4">
                                                    <span class="lpg-title fs-5">
                                                        Descripción de la oportunidad:
                                                    </span>
                                                    <p class="lpg-desc mt-3 text-justify">
                                                       {{jobposting.full_description}}
                                                    </p>
                                                </div>        
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3 gy-3">
                                        <div class="col-12 col-lg-6 ">
                                            <span class="lpg-title fs-5">
                                                Funciones:
                                            </span>
                                            <p class="lpg-desc">
                                                {{jobposting.job_responsibilities}}
                                            </p>
                                        </div>
                                        <div class="col-12 col-lg-6 ">
                                            <span class="lpg-title fs-5">
                                                Requisitos:
                                            </span>
                                            <p class="lpg-desc">
                                                <ul>
                                                     {{jobposting.required_qualifications}}
                                                </ul>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </section>                            
                        </div>
                    </div>
                    <div class="container pt-2">
                        <div class="row align-items-center">
                            <div v-if="jobposting.salary_to_be_agreed == false" class="col-12 col-lg-6 offset-lg-6 text-end">
                                <span v-if="jobposting.salary_max == jobposting.salary_min && jobposting.salary_max > 0 && jobposting.salary_min > 0 " class="lpg-title fs-5">
                                    Salario: ${{jobposting.salary_max}}
                                </span>
                                <span class="lpg-title fs-5" v-else-if="jobposting.salary_max > 0 && jobposting.salary_min > 0 " >
                                    Salario: ${{jobposting.salary_min}} - ${{jobposting.salary_max}}
                                </span>
                                <span class="lpg-title fs-5" v-else >
                                </span>
                            </div>
                            <div v-else class="col-12 col-lg-6 offset-lg-6 text-end">
                                <span class="lpg-title fs-5">
                                    Salario: A Convenir
                                </span>
                            </div>
                            <div class="col-12 mt-3">
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
        </div>        
    </div>
    <!-- End section one with image on right -->
    
  </div>
</template>

<script>
import { Head,Link } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas.vue'
import TextInput from '@/Components/Form/TextInput'
import SidebarLinkItem from '@/Components/SidebarLinkItem'

export default {
  name: 'CompanyJobPostingIndex',
  layout: LayoutEmpresas,
  components: { Head, TextInput, SidebarLinkItem, Link },
  props: {
    jobposting: Object,
    auth_token:Object,
  },
  data() {
    return {
        editMode: false,
        isOpen: false,
    }
  },
  methods:{
        deleteRow(id) {
            if (!confirm('¿Esta seguro que quiere eliminar esta oferta de trabajo?')) return;
            this.$inertia.delete('/empresas/ofertas/'+ id +'/delete');
        },
  },
  computed: {
    name() {
      return this.$page.props.auth.profile.fullname.split(' ')[0]
    },
  },
}
</script>

<style scoped>
.card-gradient {
  background: linear-gradient(90deg, #f8ff00 0%, #3ad59f 100%);
}
</style>
